import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

export function AiHubFilterLabelCell({ label }: { label: string }) {
  const text = label.trim();
  const isEmpty = !text;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <Typography
        noWrap
        sx={{
          color: isEmpty ? "#8c8c8c" : "inherit",
          fontSize: "14px",
        }}
      >
        {isEmpty ? "-" : text}
      </Typography>
    </Box>
  );
}

export function AiHubObjectIdCell({
  id,
  link,
}: {
  id: string;
  link?: string;
}) {
  const href = link?.trim() ?? "";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        width: "100%",
      }}
    >
      {href ? (
        <Link
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          underline="none"
          aria-label={`Open ${id}`}
          onClick={(event) => {
            event.stopPropagation();
          }}
          sx={{
            color: "#295EF1",
            fontSize: "14px",
            fontWeight: 500,
            textAlign: "left",
          }}
        >
          {id}
        </Link>
      ) : (
        <Typography noWrap sx={{ color: "inherit", fontSize: "14px" }}>
          {id}
        </Typography>
      )}
    </Box>
  );
}
